/**
 * <s-decal-reveal> keeps the tumbler decal picker tucked inside a <details>.
 * Opens it when the required decal hasn't been picked (so the browser can point to it),
 * shows the chosen decal's name on the toggle, and closes the picker after a pick.
 */
class DecalReveal extends HTMLElement {
  connectedCallback() {
    this.details = this.querySelector('details');
    this.chosen = this.querySelector('[data-sd-decal-chosen]');
    if (!this.details) return;
    this.onInvalid = () => { this.details.open = true; };
    this.onChange = (event) => {
      const input = event.target;
      if (!(input instanceof HTMLInputElement) || input.type !== 'radio' || !input.checked) return;
      if (this.chosen) {
        this.chosen.textContent = input.value;
        this.chosen.hidden = false;
      }
      this.details.open = false;
      this.details.querySelector('summary')?.focus();
    };
    this.addEventListener('invalid', this.onInvalid, true);
    this.addEventListener('change', this.onChange);
  }

  disconnectedCallback() {
    this.removeEventListener('invalid', this.onInvalid, true);
    this.removeEventListener('change', this.onChange);
  }
}

if (!customElements.get('s-decal-reveal')) customElements.define('s-decal-reveal', DecalReveal);
